import React from "react";
import NeoSpectraN from "../../assets/images/neospectraN.png";

const SplashScreenView = () => {
    return (
        <div className="w-screen h-screen flex items-center justify-center">
            <span className="inline-block animate-bounce">
                <img width={50} src={NeoSpectraN} alt="NeoSpectra logo" />
            </span>
        </div>
    );
};

export default SplashScreenView;
